// BoxCast pricing helper methods

export function inferVisiblityOptionFromPriceSettings(obj) {
  if (obj.is_ticketed) {
    if (obj.free_variant == 'none') {
      return 'ticketed';
    } else {
      return 'flex';
    }
  } else if (obj.is_private) {
    return 'private';
  } else {
    return 'public';
  }
}

// FUTURE: it's debatable whether it should be split by type or combinations of
// is_private, is_ticketed, free_variant, etc. --  we should discuss this more
// when we talk through updating/simplifying the pricing model
export function updatePriceSettingsFromVisibilityOption(obj, visibility, isChannel = false) {
  // Note: `obj` could be a channel or a broadcast

  // NOTE: We don't support ticketed channels in Video Portals (yet).
  // We don't mess with the validation here, because it should never reach that state.
  // If there are errors, it should show them during channel validation when creating/editing a channel.

  switch (visibility) {
    case 'public':
      obj.is_ticketed = false;
      if (!isChannel) obj.is_private = false;
      obj.ticket_price = null;
      obj.free_variant = null;
      break;
    case 'private':
      obj.is_ticketed = false;
      obj.is_private = true;
      obj.ticket_price = null;
      obj.free_variant = null;
      break;
    case 'ticketed':
      obj.is_ticketed = true;
      obj.is_private = isChannel ? true : false; // don't support ticketed channels in video portal yet
      obj.free_variant = 'none';
      break;
    case 'flex':
      obj.is_ticketed = true;
      obj.is_private = isChannel ? true : false; // don't support ticketed channels in video portal yet
      obj.free_variant = 'low';
      break;
  }

  return obj;
}



// WEBPACK FOOTER //
// ./app/utils/pricing.js